import { render, staticRenderFns } from "./LTextArea.vue?vue&type=template&id=24ff3200"
import script from "./LTextArea.vue?vue&type=script&lang=js"
export * from "./LTextArea.vue?vue&type=script&lang=js"
import style0 from "./LTextArea.vue?vue&type=style&index=0&id=24ff3200&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports